module.exports = __webpack_public_path__ + "assets/img/img230.5b4d8091.png";